module.exports = __webpack_public_path__ + "img/bailiffs_security_upperlayer.0590fa0f.svg";